/**
 * GeofenceExceptionsPage — route entry for the Admin Geofence Exceptions &
 * Overrides module (ODE-P07-T07). Applies the client-side permission mirror
 * (UX only — the server-side OD-015 `geofence.override.view` guard on every
 * endpoint remains the authority) and renders the module. Test seams are passed
 * through (no real fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-049, ODE-PRD-REQ-067, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasStaffPermission } from '../../rbac/catalog.js';
import { GeofenceExceptionsModule, type GeofenceExceptionsSeams } from './GeofenceExceptionsModule.js';

export function GeofenceExceptionsPage({
  seams,
}: {
  readonly seams?: GeofenceExceptionsSeams;
} = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasStaffPermission(session.staff.roles, 'geofence.override.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin geofence.override.view untuk halaman ini.',
        }}
      />
    );
  }
  return <GeofenceExceptionsModule seams={seams ?? {}} />;
}
